export default "__VITE_ASSET__DEdaMOsW__"